import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { format } from "date-fns";
import { connect } from "react-redux";
import Zoom from "react-medium-image-zoom";
import "react-medium-image-zoom/dist/styles.css";

import Pagination from "../../../layout/Pagination";
import { string_uppercase } from "../../../../utilities/_string_uppercase";

import OutletCallLocation from "./components/outletLocation";
import LoadingCard from "./components/loading";
import KYCHistoryCard from "./components/kycHistoryCard";

import image_not_found_img from "./../../../../img/image-not-found.png";
import event_img from "./../../../../img/calls_card/event.svg";
import bmcc_img from "./../../../../img/calls_card/bmcc.svg";
import spot_img from "./../../../../img/calls_card/spot.svg";
import "./style.scss";
import Footer from "../../../Footer/Footer";
import FieldForceCard from "../../../FieldForce/components/FieldForceCard";
import AxiosClient from "../../../../Network/AxiosClient";
import { getOutletTypeClassName } from "../../../Calls/utils/callHelper";

const config_outlet_details = [
  { key: "call_outcome", title: "Call outcome" },
  { key: "zone_aware_upload_time", title: "Call time", type: "date" },

  {
    key: "field_force__name",
    secondaryKey: "field_force__whitelisting_number",
    title: "Field force",
  },
  { key: "bmcc__code", secondaryKey: "bmcc__name", title: "BMCC" },
  {
    key: "spot_code__code",
    secondaryKey: "spot_code__name",
    title: "Spot",
  },
];

const config_extra_online = [
  { key: "address", title: "Merchant address" },
  { key: "outlet__tagging_date", title: "Lead tagging date", type: "date" },
  { key: "outlet__lead_source", title: "Lead source" },

  {
    key: "wallet_number",
    title: "Regestration wallet no.",
  },
  { key: "note", title: "Call note" },
];

class OutletsDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      outlet_basic_info: null,
      outlet_calls_history: null,
      outlet_total_calls: null,
      outlet_calls_limit: null,
      outlet_kyc_history: null,

      data_fetching: false,
      kyc_fetching: false,
    };
  }

  componentDidMount() {
    this.set_outlet_basic_info();
    this.set_outlet_calls_history();
    this.set_outlets_kyc_history();
  }

  set_outlet_basic_info() {
    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/outlets/v1/${this.props.match.params.id}`
    )
      .then((res) => {
        return this.setState({
          outlet_basic_info: res.data,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  set_outlet_calls_history() {
    this.setState({
      data_fetching: true,
    });

    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/outlets/v1/${this.props.match.params.id}/calls?page_index=${this.props.currentPage}&page_size=12`
    )
      .then((res) => {
        return this.setState({
          outlet_calls_history: res.data.data,
          outlet_total_calls: res.data.count,
          outlet_calls_limit: res.data.limit,

          data_fetching: false,
        });
      })
      .catch(() =>
        this.setState({
          data_fetching: false,
        })
      );
  }

  set_outlets_kyc_history() {
    this.setState({ kyc_fetching: true });

    AxiosClient.get(
      `${process.env.REACT_APP_API_URL}/api/outlets/v1/${this.props.match.params.id}/kyc-history`
    )
      .then((res) => {
        return this.setState({
          outlet_kyc_history: res.data,
          kyc_fetching: false,
        });
      })
      .catch(() => this.setState({ kyc_fetching: false }));
  }

  render() {
    const localUserToken = JSON.parse(localStorage.getItem("currUserToken"));
    if (!localUserToken) return <Redirect to="/signin" />;
    const scope = localStorage.getItem("scope");

    return (
      <div className="main-container">
        <div className="outlet-detail-container">
          {this.state.outlet_basic_info && (
            <div className="row">
              <div className="col l6 s12">
                <div className="outlet-section section-left">
                  <Zoom>
                    <img
                      src={
                        this.state.outlet_basic_info.image ||
                        image_not_found_img
                      }
                      alt="outlet"
                    />
                  </Zoom>
                  <div className="outlet-description outlet-description--right">
                    {this.state.outlet_basic_info && (
                      <span className="outlet-name">
                        {string_uppercase(this.state.outlet_basic_info.name)}
                      </span>
                    )}

                    <div className="outlet-phone">
                      {this.state.outlet_basic_info.wallet_no ? (
                        <>
                          <div className="value">
                            {this.state.outlet_basic_info.wallet_no}
                          </div>
                          <div className="tag">Merchant Wallet Number</div>
                        </>
                      ) : (
                        <>
                          <div className="value">
                            {
                              this.state.outlet_basic_info
                                .contact_person_phone_number
                            }
                          </div>
                          <div className="tag">Merchant Contact Number</div>
                        </>
                      )}
                    </div>
                    <span
                      style={{ borderLeftWidth: 0, paddingLeft: 0 }}
                      className={getOutletTypeClassName(
                        this.state.outlet_basic_info.outlet_type
                      )}
                    >
                      {string_uppercase(
                        this.state.outlet_basic_info.outlet_type
                      )}
                    </span>
                    <div className="outlet-call__mdo">
                      <div className="call">
                        <div className="value">
                          {this.state.outlet_basic_info.call_count}
                        </div>
                        <div className="tag">Total Calls To This Outlet</div>
                      </div>
                      <div className="mdo">
                        <div className="value">
                          {this.state.outlet_basic_info.mdo_count}
                        </div>
                        <div className="tag">MDOs Covered This Outlet</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col l6 s12">
                <div className="outlet-section section-right">
                  <div className="outlet-description outlet-description--left">
                    <div className="info">
                      <img src={event_img} alt="bmcc img" />
                      <div className="data">
                        Last Call Date & Time
                        <span>
                          {this.state.outlet_basic_info.last_call
                            ? // ? moment(
                              //     this.state.outlet_basic_info.last_call
                              //   ).format("llll")
                              format(
                                new Date(
                                  this.state.outlet_basic_info.last_call
                                ),
                                "EEE, MMM d yyyy h:mm a"
                              )
                            : "..."}
                        </span>
                      </div>
                    </div>

                    <div className="info">
                      <img src={bmcc_img} alt="bmcc img" />
                      <div className="data">
                        <span>
                          {this.state.outlet_basic_info.bmcc_id || "..."}
                        </span>
                        <span className="code-description bmcc-code-description">
                          {this.state.outlet_basic_info.bmcc__name || "..."}
                        </span>
                      </div>
                    </div>

                    <div className="info">
                      <img src={spot_img} alt="bmcc img" />
                      <div className="data">
                        <span>
                          {this.state.outlet_basic_info.spot_code_id || "..."}
                        </span>
                        <span className="code-description">
                          {this.state.outlet_basic_info.spot_code__name ||
                            "..."}
                        </span>
                      </div>
                    </div>
                  </div>
                  {this.state.outlet_basic_info.lat &&
                    this.state.outlet_basic_info.lng && (
                      <OutletCallLocation
                        location={[
                          this.state.outlet_basic_info.lat,
                          this.state.outlet_basic_info.lng,
                        ]}
                      />
                    )}
                </div>
              </div>
            </div>
          )}

          <div className="page-header">
            <div className="page-heading">
              Call History
              <div className="page-sub-heading">
                {this.state.outlet_total_calls} Calls Till Date
              </div>
            </div>
          </div>

          <Pagination
            page={"outlet_detail"}
            currentPage={this.props.currentPage}
            total={this.state.outlet_total_calls}
            limit={this.state.outlet_calls_limit}
          />

          <div className="outlet-call-cards">
            {this.state.data_fetching ? (
              <LoadingCard />
            ) : (
              <div className="card-row row">
                {this.state.outlet_calls_history &&
                  this.state.outlet_calls_history.map((item, index) => (
                    <FieldForceCard
                      info={item}
                      key={index}
                      config={
                        scope === "online"
                          ? [...config_outlet_details, ...config_extra_online]
                          : [...config_outlet_details]
                      }
                      isLargeSized={true}
                    />
                  ))}
              </div>
            )}
          </div>

          <Pagination
            page={"outlet_detail"}
            currentPage={this.props.currentPage}
            total={this.state.outlet_total_calls}
            limit={this.state.outlet_calls_limit}
          />
        </div>
        <div className="kyc-history-card-container">
          {this.state.kyc_fetching ? (
            <LoadingCard />
          ) : (
            <>
              <div className="kyc-heading">
                <div className="kyc-headline">KYC History</div>
                <div className="kyc-sub-headline">Activity Summary</div>
              </div>
              <div className="card-row row kyc-history-cards">
                {this.state.outlet_kyc_history &&
                  this.state.outlet_kyc_history.map((item, index) => (
                    <div className="card-col col l12 s12 m12">
                      <KYCHistoryCard history={item} key={index} />
                    </div>
                  ))}
              </div>
            </>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let currentPage = state.page.outlet_detail
    ? state.page.outlet_detail.currentPage
    : state.page.default.currentPage;
  return { currentPage };
};

export default connect(mapStateToProps, null)(OutletsDetail);
